/**
 * Newsletter Sign-up popup
 */

jQuery( document ).ready(
	function($) {
		function NEWSLETTERSIGNUP() {
			/*
			*
			* OBJECTS, VARIABLES AND ARRAYS
			*
			*/

			// Popup HTML
			this.html = '<!-- Modal -->' +
				'<div class="popup__newsletter_signup" id="popup__newsletter_signup">' +
				'<div class="popup__newsletter_signup--header">' +
				'<h3 class="popup__newsletter_signup--title">Title</h3>' +
				'<button type="button" class="popup__newsletter_signup--close" data-tracking="newsletter_popup_close">&times;</button>' +
				'</div>' +
				'<div class="popup__newsletter_signup--body">Message</div>' +
				'<div class="popup__newsletter_signup--footer">' +
				'</div>' +
				'</div>';
			// Popup id
			this.popup_id = '#popup__newsletter_signup';
			// Get popup info AJAX send data
			this.data_popup = {
				ajax_action: 'popup_data',
				post_id: ''
			};
			// AJAX file URL for getting popup info
			this.main_ajax_url = '/wp-content/themes/JTF-child/functions/newsletter-signup/ajax.php';
			// Cookie status
			this.cookie_status = '';
			// Load event listeners
			this.event_listeners();
		}

		/*
		*
		* FUNCTIONS
		*
		*/
		NEWSLETTERSIGNUP.prototype.ajax_request = function ( request_method, data_type, send_data, url ) {
			const self = this;
			$.ajax({
				type: request_method,
				dataType: data_type,
				data: send_data,
				url: url,
				beforeSend: function () {
				},
				success: function ( data ) {
					// Convert json data into object
					let result = JSON.parse( data );
					// If field data returned by AJAX file
					//console.log( result );
					if ( 'data_exists' == result.status ) {
						// Set the popup title
						$( '.popup__newsletter_signup--title' ).text( result.title );
						// Set the popup form
						$( '.popup__newsletter_signup--body' ).html( result.gravity_form );
						// Fade in modal after 5 seconds
						let modal = function () {
							$( self.popup_id ).fadeIn( 1000 );
							//console.log( 'NEWSLETTERSIGNUP: Modal active' );
						};
						//console.log( 'DELAY TIME:' + result.delay_time );
						setTimeout( modal, result.delay_time );
						// If NO field data returned by AJAX file
					} else if ( 'no_data' == result.status ) {
						//console.log( 'NEWSLETTERSIGNUP: No field data returned from AJAX request' );
					}
				},
				error: function ( jqXHR, textStatus, errorThrown ) {
					console.log( 'NEWSLETTERSIGNUP: AJAX error: ' + jqXHR + " | " + textStatus + " | " + errorThrown );
				}
			})
		};

		NEWSLETTERSIGNUP.prototype.event_listeners = function () {
			const self = this;
			// Window load
			$( window ).load(
				function() {
					console.log( 'JTF NEWSLETTER SIGN-UP' );
					// Get the cookie status
					self.cookie_status =
						self.get_cookie( 'newsletter_signup_popup' )
							.substring(
								0,
								self.get_cookie(
									'newsletter_signup_popup'
								).indexOf('|')
							);
					if ( 'enabled' == self.cookie_status ) {
						// Add HTML
						$( 'body' ).after( self.html );
						// Hide popup
						$( self.popup_id ).hide();
						//console.log( 'VERSION: ' + self.data_popup.version );
						// Add the post id to the data object
						self.data_popup.post_id = self.get_cookie( 'newsletter_signup_popup' ).split('|').pop();
						//console.log( 'POST ID: ' + self.data_popup.post_id );
						// Get the modal information and display modal
						self.ajax_request( 'POST', 'html', self.data_popup, self.main_ajax_url );
						// On click on close modal button
						$( self.popup_id ).find( '.popup__newsletter_signup--close' ).click(
							function () {
								//console.log( 'NEWSLETTERSIGNUP: Modal closed' );
								document.cookie = "newsletter_signup_popup=closed; path=/";
								$( self.popup_id ).hide();
							}
						);
					}
				}
			)
		};
		// JS get cookie decode function
		NEWSLETTERSIGNUP.prototype.get_cookie = function ( cname ) {
			let name = cname + "=";
			let decodedCookie = decodeURIComponent( document.cookie );
			let ca = decodedCookie.split( ';' );
			for ( let i = 0; i < ca.length; i++ ) {
				let c = ca[i];
				while ( c.charAt(0) == ' ' ) {
					c = c.substring(1);
				}
				if ( c.indexOf(name) == 0 ) {
					return c.substring( name.length, c.length );
				}
			}
			return "";
		};

		// Load scripts if ebook popup is enabled
		if ( $( 'body' ).hasClass( 'newsletter_signup_popup_enabled' ) ) {
			let scripts = new NEWSLETTERSIGNUP();
		}
	}
);